import React, { useState, useEffect, useRef } from "react";
import { IoInformationCircleOutline, IoCopyOutline } from "react-icons/io5";

function PoolRulesPopover({ maxPlayers, numPlayersScored, allMustMakeCut, tieBreaker, onCopyLink }) {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const rules = [
    { label: "Players Per Team", value: maxPlayers || "--" },
    { label: "Players Scored", value: numPlayersScored || "--" },
    { label: "Cut Rule", value: allMustMakeCut ? "All Must Make Cut" : "No Cut Rule" },
    { label: "Tie Breaker", value: tieBreaker || "None" },
  ];

  const handleCopyLink = () => {
    if (onCopyLink) {
      onCopyLink();
      setIsOpen(false);
    }
  };

  const RulesContent = () => (
    <div className="space-y-3">
      <h3 className="text-sm font-bold text-gray-900">Pool Rules</h3>
      <div className="space-y-2">
        {rules.map((rule) => (
          <div key={rule.label} className="flex items-center justify-between">
            <span className="text-xs text-gray-500">{rule.label}</span>
            <span className="text-xs font-semibold text-gray-900">{rule.value}</span>
          </div>
        ))}
      </div>
      {onCopyLink && (
        <button
          onClick={handleCopyLink}
          className="w-full flex items-center justify-center gap-2 mt-1 py-2 px-3 bg-primary hover:bg-primary-hover text-white text-xs font-semibold rounded-lg transition-colors"
        >
          <IoCopyOutline className="w-3.5 h-3.5" />
          Copy Public Link
        </button>
      )}
    </div>
  );

  return (
    <div className="relative" ref={popoverRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-9 h-9 bg-white/20 hover:bg-white/30 text-white rounded-xl transition-all"
      >
        <IoInformationCircleOutline className="w-5 h-5" />
      </button>

      {isOpen && (
        <>
          {/* Desktop popover */}
          <div className="hidden md:block absolute right-0 top-full mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 p-4 z-50">
            <RulesContent />
          </div>

          {/* Mobile bottom sheet */}
          <div className="md:hidden">
            <div className="fixed inset-0 bg-black/30 z-40" onClick={() => setIsOpen(false)} />
            <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-xl border-t border-gray-200 z-50 p-5 pb-8">
              <RulesContent />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PoolRulesPopover;
